import CustomImage from '../../fragments/custom-image/CustomImage';
import Cinemagraph from '../cinemagraph/Cinemagraph';

import { useRef, useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'motion/react';

import CardLink from './CardLink';

export default function CardPost({
  card,
  aspectRatio = '682/816',
  parentRef = false,
  followCursor = true,
  parallax = true,
  // fullQuality = false,
}) {
  const isInternal = card?.link?.url?.startsWith('/');

  const ref = useRef(null);
  const lastMouseY = useRef(null);
  const y = useSpring(useMotionValue(0), {
    damping: 50,
    stiffness: 300,
    mass: 0.5,
  });

  const verticalPadding = 32;

  const updatePosition = (clientY) => {
    if (!ref.current) return;

    const { top, bottom } = ref.current.getBoundingClientRect();

    if (clientY > top + verticalPadding && clientY < bottom - verticalPadding) {
      y.set(clientY - top);
    }
  };

  const handleMouse = (e) => {
    lastMouseY.current = e.clientY;
    updatePosition(e.clientY);
  };

  const handleMouseEnter = (e) => {
    lastMouseY.current = e.clientY;
    updatePosition(e.clientY);
  };

  const handleMouseLeave = () => {
    lastMouseY.current = null;
  };

  useEffect(() => {
    if (!followCursor) return;

    const handleScroll = () => {
      if (lastMouseY.current !== null) {
        updatePosition(lastMouseY.current);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [followCursor]);

  // Guard sits below every hook so the hook order is identical on every render.
  if (!card) return null;

  return (
    <div
      className={`cardPost ${
        followCursor ? 'cardPost--cursor' : 'cardPost--noCursor'
      }`}
      ref={ref}
      {...(followCursor && {
        onMouseMove: handleMouse,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      })}
    >
      <CardLink
        url={card.link?.url}
        isInternal={isInternal}
        title={card.link?.title}
      >
        <motion.div
          className="cardPost-text"
          style={{ top: followCursor ? y : '50%' }}
        >
          <div className="cardPost-textInner">
            {card.heading && <p className="cardPost-heading">{card.heading}</p>}
            {card.label && <p className="cardPost-date">{card.label}</p>}
          </div>
        </motion.div>

        <div className="cardPost-media">
          <div style={{ aspectRatio: aspectRatio }}>
            <CustomImage
              image={card.image}
              fill={true}
              // parallax={parallax}
              sizes={'100vw'}
              forceLoad={true}
              parentRef={parentRef}
            />
          </div>
        </div>
      </CardLink>
    </div>
  );
}
